function Page() {
  return (
    <div className="w-100 h-100 flex flex-center flex-middle">
      <h1 style={{ fontSize: "40px" }}>欢迎登录</h1>
    </div>
  );
}
export default Page;
